import type {
  GroupBase,
  GroupHeadingProps as ReactSelectGroupHeadingProps,
} from 'react-select';

import { useBehavioralTrackingProps } from '../../../core/hooks/useBehavioralTrackingProps.js';
import type { BehaviorTrackingProps } from '../../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../../core/types/data-props.js';
import { StylingProps } from '../../../core/types/styling-props.js';
import { Flex } from '../../../layouts/flex/Flex.js';
import { Text } from '../../../typography/text/Text.js';
import * as styles from '../styles/Select.sty.js';

type GroupHeadingProps<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
> = ReactSelectGroupHeadingProps<
  OptionValue,
  isMulti,
  Group & { labelProps?: StylingProps & DataTestId & BehaviorTrackingProps }
>;

export function GroupHeading<
  OptionValue,
  isMulti extends boolean,
  Group extends GroupBase<OptionValue>,
>(props: GroupHeadingProps<OptionValue, isMulti, Group>) {
  const {
    id,
    children,
    data: { labelProps },
  } = props;
  const {
    className: consumerClassName,
    style: consumerStyle,
    'data-testid': dataTestId,
  } = labelProps ?? {};

  const [labelTrackingProps] = useBehavioralTrackingProps(labelProps ?? {});

  return (
    <Flex
      paddingX={12}
      paddingTop={12}
      paddingBottom={4}
      className={consumerClassName}
      style={consumerStyle}
      data-testid={dataTestId}
      {...labelTrackingProps}
    >
      <Text
        as="span"
        id={id}
        textStyle="small-emphasized"
        className={styles.selectGroupHeading}
      >
        {children}
      </Text>
    </Flex>
  );
}
